
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilterDefinition, SavedFilter } from '../core/list-layout.types';
import { debounce, generateId } from '../core/list-layout.utils';
import DatePicker from '../../DatePicker.vue';
import NSelect from '../../NSelect.vue';

@Component({
    components: {
        DatePicker,
        NSelect,
    },
})
export default class ListLayoutFilters extends Vue {
    @Prop({ type: Object, required: true }) filters!: Record<string, any>;
    @Prop({ type: Array, default: () => [] }) filterDefinitions!: FilterDefinition[];
    @Prop({ type: Array, default: () => [] }) savedFilters!: SavedFilter[];
    @Prop({ type: Boolean, default: false }) enableSavedFilters!: boolean;

    localFilters: Record<string, any> = {};
    searchText = '';
    showAdvanced = false;
    showSaveDialog = false;
    saveFilterName = '';
    saveFilterAsDefault = false;

    rules = {
        required: (v: any) => !!v || this.$i18n.t('common.thisFileIsRequired'),
    };

    get simpleFilters(): FilterDefinition[] {
        return this.filterDefinitions.filter((f) => f.visible !== false && !f.advanced);
    }

    get advancedFilters(): FilterDefinition[] {
        return this.filterDefinitions.filter((f) => f.visible !== false && f.advanced);
    }

    get hasActiveFilters(): boolean {
        return Object.keys(this.localFilters).some((key) => {
            const value = this.localFilters[key];
            return value !== null && value !== undefined && value !== '';
        });
    }

    mounted() {
        this.localFilters = { ...this.filters };
    }

    @Watch('filters', { deep: true })
    onFiltersChange(newFilters: Record<string, any>) {
        this.localFilters = { ...newFilters };
    }

    handleSearchChange = debounce(() => {
        if (this.searchText) {
            this.localFilters.search = this.searchText;
        } else {
            delete this.localFilters.search;
        }
        this.emitFiltersUpdate();
    }, 300);

    handleFilterChange = debounce(() => {
        this.emitFiltersUpdate();
    }, 300);

    emitFiltersUpdate() {
        const cleanFilters = Object.keys(this.localFilters).reduce((acc, key) => {
            const value = this.localFilters[key];
            if (value !== null && value !== undefined && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {} as Record<string, any>);

        this.$emit('update:filters', cleanFilters);
    }

    handleClearFilters() {
        this.localFilters = {};
        this.searchText = '';
        this.emitFiltersUpdate();
    }

    handleLoadSavedFilter(filterId: string) {
        this.$emit('load-filter', filterId);
    }

    handleDeleteSavedFilter(filterId: string) {
        this.$emit('delete-filter', filterId);
    }

    handleSaveFilter() {
        const savedFilter: SavedFilter = {
            id: generateId(),
            name: this.saveFilterName,
            filters: { ...this.localFilters },
            isDefault: this.saveFilterAsDefault,
            createdAt: new Date(),
        };

        this.$emit('save-filter', savedFilter);
        this.closeSaveDialog();
    }

    closeSaveDialog() {
        this.showSaveDialog = false;
        this.saveFilterName = '';
        this.saveFilterAsDefault = false;
    }
}
